import React from 'react';

import Button from '@/components/ui/buttons/Button';
import GradeClassNumberLabel from '@/components/ui/formats/GradeClassNumberLabel';
import ErrorList from '@/components/ui/forms/ErrorList';
import { type InvitationStudent } from '@/interfaces/invitation';

import styles from './InvitationRegisterConfirmForm.module.scss';
import { type InvitationRegisterFormValues } from './InvitationRegisterInputForm';

interface Props {
  formValues: InvitationRegisterFormValues;
  student: InvitationStudent;
  apiError?: string[];
  submitButtonDisabled: boolean;
  onBack: () => void;
  onSubmit: () => void;
}

const InvitationRegisterConfirmForm: React.FC<Props> = ({
  formValues,
  student,
  apiError,
  submitButtonDisabled,
  onBack,
  onSubmit,
}) => (
  <div className={styles.InvitationRegisterConfirmForm}>
    <div className={styles.InvitationRegisterConfirmForm__Description}>
      以下の内容でアカウントの登録を行います。詳細をご確認ください。
    </div>
    <div className={styles.InvitationRegisterConfirmForm__Content}>
      <div className={styles.InvitationRegisterConfirmForm__Item}>
        <div className={styles.InvitationRegisterConfirmForm__ItemLabel}>
          保護者氏名
        </div>
        <div className={styles.InvitationRegisterConfirmForm__ItemValue}>
          {formValues.last_name}
          &nbsp; &nbsp;
          {formValues.first_name}
        </div>
      </div>
      <div className={styles.InvitationRegisterConfirmForm__Item}>
        <div className={styles.InvitationRegisterConfirmForm__ItemLabel}>
          保護者氏名（かな）
        </div>
        <div className={styles.InvitationRegisterConfirmForm__ItemValue}>
          {formValues.last_name_kana}
          &nbsp; &nbsp;
          {formValues.first_name_kana}
        </div>
      </div>
      <div className={styles.InvitationRegisterConfirmForm__Item}>
        <div className={styles.InvitationRegisterConfirmForm__ItemLabel}>
          メールアドレス
        </div>
        <div className={styles.InvitationRegisterConfirmForm__ItemValue}>
          {formValues.email}
        </div>
      </div>
      <div className={styles.InvitationRegisterConfirmForm__Item}>
        <div className={styles.InvitationRegisterConfirmForm__ItemLabel}>
          パスワード
        </div>
        <div className={styles.InvitationRegisterConfirmForm__ItemValue}>
          {'●●●●●●●●●'}
        </div>
      </div>
    </div>
    <div className={styles.InvitationRegisterConfirmForm__StudentCard}>
      <div
        className={
          styles.InvitationRegisterConfirmForm__StudentCard__StudentInformations
        }
      >
        <div
          className={
            styles.InvitationRegisterConfirmForm__StudentCard__OrganizationName
          }
        >
          {student.organization_name}
        </div>
        <GradeClassNumberLabel
          gradeLabel={student.grade}
          classNameLabel={student.class_name ?? undefined}
          attendanceNumberLabel={student.attendance_number ?? undefined}
        />
        <div
          className={
            styles.InvitationRegisterConfirmForm__StudentCard__StudentName
          }
        >
          {student.name}
        </div>
      </div>
    </div>
    {apiError && apiError.length > 0 && (
      <ErrorList
        className={styles.InvitationRegisterConfirmForm__Errors}
        errors={apiError}
      />
    )}
    <div className={styles.InvitationRegisterConfirmForm__Buttons}>
      <Button
        type="button"
        color="primary"
        size="m"
        onClick={onSubmit}
        disabled={submitButtonDisabled}
      >
        登録する
      </Button>
      <Button type="button" color="link" size="m" onClick={onBack}>
        ＜戻る
      </Button>
    </div>
  </div>
);

export default InvitationRegisterConfirmForm;
